import React from 'react';

import { Modal } from 'components/form/prototypes'

const CancelModal = ({ showModal, setShowModal, callback }) => {

  const handleYes = () => {
    setShowModal(false);
    callback();
  }

  const handleNo = () => {
    setShowModal(false);
  }

  const text = {
    body: (
      <>
        By proceeding, the NCR will be <b><font color='red'>CANCELLED</font></b>.<br />
        <br />Are you sure you would like to <b><font color='red'>CANCEL</font></b> the NCR?
      </>
    ),
    yes: <>Yes, I'm sure</>,
    no: <>No, keep this NCR active</>
  }

  return (
    <Modal showModal={showModal} setShowModal={setShowModal} handleYes={handleYes} handleNo={handleNo} text={text} />
  )
}

export { CancelModal };
